export const WEBSITEMETA_LOADING = "WEBSITEMETA_LOADING";
export const WEBSITEMETA_IDLE = "WEBSITEMETA_IDLE";
export const WEBSITEMETA_SAVE = "WEBSITEMETA_SAVE";

export const MAINPROMO_ITEMS_SAVE = "MAINPROMO_ITEMS_SAVE";

export const TOUR_LOADING = "TOUR_LOADING";
export const TOUR_IDLE = "TOUR_IDLE";
export const TOUR_DATA_SAVE = "TOUR_DATA_SAVE";

export const FEATURED_PACKAGE_SAVE = "FEATURED_PACKAGE_SAVE";
export const FEATURED_ADDON_SAVE = "FEATURED_ADDON_SAVE";

export const COUNTRIES_INFO_SAVE = "COUNTRIES_INFO_SAVE";

// ========================= PROFILE ACTIONS =========================
export const GUESTPROFILE_SAVE = "GUESTPROFILE_SAVE";
export const GUESTPROFILE_RESET = "GUESTPROFILE_RESET";
